export default __webpack_public_path__ + "static/media/cubits-logo.64b34b9d.png";